import { LAMPORTS_PER_SOL } from '@solana/web3.js'

import { POSTWithAuthNoResponse } from './Index'

export async function videoSupply(
  mint: string,
  price: number,
  min_editions: number,
  max_editions: number
): Promise<void> {
  return await POSTWithAuthNoResponse(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/videos/${mint}/supply`,
    {
      price: price * LAMPORTS_PER_SOL,
      min_editions: min_editions,
      max_editions: max_editions * LAMPORTS_PER_SOL,
    }
  )
}
